import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedIsConnecting = mutatorAction('updateAdvancedIsConnecting', function (isConnecting) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.isConnecting = isConnecting;
});
//# sourceMappingURL=updateAdvancedIsConnecting.js.map